"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var core_2 = require("@ngx-translate/core");
var flex_layout_1 = require("@angular/flex-layout");
var material_module_1 = require("../material.module");
var core_module_1 = require("../core/core.module");
var shared_module_1 = require("../shared/shared.module");
var user_selection_routing_module_1 = require("./user-selection.routing.module");
var user_selection_component_1 = require("./user-selection.component");
var user_data_service_1 = require("../core/user/user.data.service");
var edit_user_component_1 = require("./edit-user/edit-user.component");
var confirm_dialog_component_1 = require("./confirm-dialog/confirm-dialog.component");
var UserAdministrationModule = /** @class */ (function () {
    function UserAdministrationModule() {
    }
    UserAdministrationModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                core_2.TranslateModule,
                core_module_1.CoreModule,
                shared_module_1.SharedModule,
                forms_1.FormsModule,
                forms_1.ReactiveFormsModule,
                flex_layout_1.FlexLayoutModule,
                material_module_1.MaterialModule,
                user_selection_routing_module_1.UserAdministrationRoutingModule
            ],
            declarations: [
                user_selection_component_1.UserAdministrationComponent,
                edit_user_component_1.EditUserComponent,
                confirm_dialog_component_1.ConfirmDialogComponent
            ],
            entryComponents: [
                edit_user_component_1.EditUserComponent,
                confirm_dialog_component_1.ConfirmDialogComponent
            ],
            providers: [
                user_data_service_1.UserDataService
            ]
        })
    ], UserAdministrationModule);
    return UserAdministrationModule;
}());
exports.UserAdministrationModule = UserAdministrationModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1zZWxlY3Rpb24ubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlci1zZWxlY3Rpb24ubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHNDQUF5QztBQUN6QywwQ0FBK0M7QUFDL0Msd0NBQWtFO0FBQ2xFLDRDQUFzRDtBQUN0RCxvREFBd0Q7QUFFeEQsc0RBQW9EO0FBQ3BELG1EQUFpRDtBQUNqRCx5REFBdUQ7QUFDdkQsaUZBQWtGO0FBQ2xGLHVFQUF5RTtBQUN6RSxvRUFBaUU7QUFDakUsdUVBQW9FO0FBQ3BFLHNGQUFtRjtBQTJCbkY7SUFBQTtJQUNBLENBQUM7SUFEWSx3QkFBd0I7UUF6QnBDLGVBQVEsQ0FBQztZQUNOLE9BQU8sRUFBRTtnQkFDTCxxQkFBWTtnQkFDWixzQkFBZTtnQkFDZix3QkFBVTtnQkFDViw0QkFBWTtnQkFDWixtQkFBVztnQkFDWCwyQkFBbUI7Z0JBQ25CLDhCQUFnQjtnQkFDaEIsZ0NBQWM7Z0JBQ2QsK0RBQStCO2FBQ2xDO1lBQ0QsWUFBWSxFQUFFO2dCQUNWLHNEQUEyQjtnQkFDM0IsdUNBQWlCO2dCQUNqQixpREFBc0I7YUFDekI7WUFDRCxlQUFlLEVBQUU7Z0JBQ2IsdUNBQWlCO2dCQUNqQixpREFBc0I7YUFDekI7WUFDRCxTQUFTLEVBQUU7Z0JBQ1AsbUNBQWU7YUFDbEI7U0FDSixDQUFDO09BQ1csd0JBQXdCLENBQ3BDO0lBQUQsK0JBQUM7Q0FBQSxBQURELElBQ0M7QUFEWSw0REFBd0IifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/user-selection/user-selection.module.ts
// module id = 630
// module chunks = 0